import { User } from '../interfaces/user-interface';

export class SessionClass {
  token: string;
  sessionId: number;
  user: User;

  constructor(token: string, sessionId: number, user: User) {
    this.token = token;
    this.sessionId = sessionId;
    this.user = user;
  }
}
